module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-ring-5-06cd65814e46acdb828977c225195768.svg";